import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "conference-actions" }

import { ref } from 'vue';
import { request } from '@/admin/shared/api/httpClient';
import CancelConferenceDialog from './CancelConferenceDialog.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConferenceActions',
  props: {
    detail: {}
  },
  setup(__props: any) {

const props = __props;

const cancelOpen = ref(false);
const busy = ref(false);

const conferenceId = (): string => String(props.detail.id);

async function promptSendInvitations(): Promise<void> {
    const input = window.prompt('Введите UUID участников через запятую:');
    if (input === null) return;
    const participantPks = input
        .split(',')
        .map((s: string) => s.trim())
        .filter((s: string) => s.length > 0);
    busy.value = true;
    try {
        await request({
            method: 'post',
            url: `/admin-api/conferences/${conferenceId()}/send-invitations/`,
            data: { participant_pks: participantPks },
        });
        window.alert('Приглашения отправлены');
    } finally {
        busy.value = false;
    }
}

async function confirmForceEnd(): Promise<void> {
    if (!window.confirm('Принудительно завершить конференцию?')) return;
    busy.value = true;
    try {
        await request({
            method: 'post',
            url: `/admin-api/conferences/${conferenceId()}/force-end/`,
            data: {},
        });
        onDone();
    } finally {
        busy.value = false;
    }
}

function onDone(): void {
    cancelOpen.value = false;
    window.location.reload();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "btn btn--danger",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (cancelOpen.value = true))
    }, "Отменить конференцию"),
    _createElementVNode("button", {
      class: "btn btn--primary",
      onClick: promptSendInvitations
    }, "Отправить приглашения"),
    _createElementVNode("button", {
      class: "btn btn--danger",
      onClick: confirmForceEnd
    }, "Принудительно завершить"),
    (cancelOpen.value)
      ? (_openBlock(), _createBlock(CancelConferenceDialog, {
          key: 0,
          open: cancelOpen.value,
          "conference-id": conferenceId,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (cancelOpen.value = false)),
          onDone: onDone
        }, null, 8, ["open"]))
      : _createCommentVNode("", true)
  ]))
}
}

})